import firebase from "firebase";
import "firebase/firestore";
const firebaseApp = firebase.initializeApp({
  apiKey: "AIzaSyDYJ5AXq3fwXZOggWphXI2SRlu-LC4sM2I",
  authDomain: "clone-aee74.firebaseapp.com",
  projectId: "clone-aee74",
  storageBucket: "clone-aee74.appspot.com",
  messagingSenderId: "703363797073",
  appId: "1:703363797073:web:3f499ab6b4e740bb5f2870",
  measurementId: "G-SF6XB0VJ1T",
});

const auth = firebase.auth();
export { auth };
